import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GAME_OVER_FEATURE_KEY, GameOverState } from './game-over.reducer';

// Lookup the 'GameOver' feature state managed by NgRx
export const getGameOverState = createFeatureSelector<GameOverState>(
  GAME_OVER_FEATURE_KEY,
);

export const getGameOverLoaded = createSelector(
  getGameOverState,
  (state: GameOverState) => state.loaded,
);
export const getGameOverResult = createSelector(
  getGameOverState,
  (state: GameOverState) => state.gameOver,
);

export const getGameOverLeaders = createSelector(
  getGameOverResult,
  (result) => result?.leaders || [],
);

export const getGameOverError = createSelector(
  getGameOverState,
  (state: GameOverState) => state.error,
);
export const getCurrentPlayInstance = createSelector(
  getGameOverState,
  (state: GameOverState) => state.selectedPlayInstance || null,
);

export const getPlayInstanceBelongingToUser = createSelector(
  getGameOverResult,
  (gameOver) => gameOver?.lastPlayInstance || null,
);

export const getGameOverBestUserRank = createSelector(
  getGameOverResult,
  (result) => result?.bestUserRank || null,
);
export const getGameOverBestUserScore = createSelector(
  getGameOverResult,
  (result) => result?.bestUserScore || 0,
);

export const getUserWom = (id: string) =>
  createSelector(
    getGameOverResult,
    getGameOverLeaders,
    (gameOver, instances) => {
      const leader = instances.find(
        (instance) =>
          instance.uuid === id && instance.rank === 1 && gameOver?.complete,
      );
      if (leader) {
        return true;
      }
      return false;
    },
  );
